exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Tree.css
// module id = ./src/components/Tree.css
// module chunks = 4016850265702045000